// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1PS9O","label":"Category_label__3zWbX","content":"Category_content__2i9Xq","header":"Category_header__26Akf","location":"Category_location__V7FIt"};